import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Attachment } from 'src/app/shared/interfaces/attachment.interface';
import { Media } from '../../interfaces/settings.interface';

@Component({
  selector: 'app-audio-item',
  templateUrl: './audio-item.component.html',
  styleUrls: ['./audio-item.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    AngularSvgIconModule,
    TranslateModule,
  ],
})
export class AudioItemComponent implements OnInit, OnChanges {
  @Input() audio: Attachment | Media;
  @Input() isHideVolume = false;
  @Input() stop = false;
  @ViewChild('audioPlayer') audioPlayer: ElementRef;

  muted = false;

  volumeSlider = null;

  @ViewChild('progressBar', { static: false })
  progressBar!: ElementRef<HTMLDivElement>;
  @ViewChild('durationEl', { static: false })
  durationEl!: ElementRef<HTMLSpanElement>;
  @Output() currentTimeChange = new EventEmitter<number>();
  audioItem!: HTMLAudioElement;
  duration: string = '0:00';
  paused = false;

  ngOnInit(): void {
    if (!this.audio) return;

    this.audioItem = new Audio(this.audio.link);

    this.audioItem.addEventListener('loadedmetadata', () => {
      this.duration = this.getTimeCodeFromNum(this.audioItem.duration);
      this.durationEl.nativeElement.textContent = `0:00 / ${this.duration}`;
    });

    this.audioItem.addEventListener('timeupdate', () => {
      const current = this.audioItem.currentTime;
      const percent = (current / this.audioItem.duration) * 100;

      this.progressBar.nativeElement.style.width = percent + '%';

      this.durationEl.nativeElement.textContent = `${this.getTimeCodeFromNum(
        current,
      )} / ${this.duration}`;

      this.currentTimeChange.emit(current);
    });

    this.audioItem.addEventListener('ended', () => {
      this.paused = false;
    });
  }
  private getTimeCodeFromNum(num: number): string {
    const minutes = Math.floor(num / 60);
    const seconds = Math.floor(num % 60);
    return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('stop' in changes) {
      this.pauseAudio();
    }
  }

  skipAround(e) {
    const timeline =
      this.audioPlayer.nativeElement.querySelector('.timeline__wrapper');
    const timelineWidth = window.getComputedStyle(timeline).width;
    this.audioItem.currentTime =
      (e.offsetX / Number.parseInt(timelineWidth)) * this.audioItem.duration;
  }
  changeVolume(e) {
    this.volumeSlider = this.audioPlayer.nativeElement.querySelector(
      '.volume__slider-wrapper',
    );
    const sliderWidth = window.getComputedStyle(this.volumeSlider).width;
    const newVolume = e.offsetX / Number.parseInt(sliderWidth);
    this.audioItem.volume = newVolume;
    this.audioPlayer.nativeElement.querySelector(
      '.controls .volume__slider-filled',
    ).style.width = newVolume * 100 + '%';
  }
  onVolumeClick() {
    this.audioItem.muted = !this.audioItem.muted;
    this.muted = !!this.audioItem.muted;
  }

  onPlayBtnClick() {
    if (this.audioItem.paused) {
      this.paused = true;
      this.audioItem.play();
    } else {
      this.paused = false;
      this.audioItem.pause();
    }
  }
  pauseAudio() {
    this.paused = false;
    this.audioItem?.pause();
  }
}
